// extracted by mini-css-extract-plugin
export default {"navigation":"Header_navigation__8M31C","color":"Header_color__lMsI5","links":"Header_links__MAKf+"};